// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'


// 获取预约列表
export function getOrderList(data) {
  const url = global.requestUrl + '/truckOrder/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}
// 创建车辆预约信息
export function createManOrderInfo(data) {
  const url = global.requestUrl + '/personOrder/create'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 创建货车预约信息
export function createTruckOrderInfo(data) {
  const url = global.requestUrl + '/truckOrder/create'
  return axios.post(url, data)
}

// 创建车辆预约信息
export function createCarOrderInfo(data) {
  const url = global.requestUrl + '/carOrderRecord/create'
  return axios.post(url, data)
}

// 获取预约列表
export function getManOrderList(data) {
  const url = global.requestUrl + '/personOrder/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取访问列表
export function getManAccessList(data) {
  const url = global.requestUrl + '/personAccess/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取预约列表
export function getTruckOrderList(data) {
  const url = global.requestUrl + '/truckOrder/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取访问列表
export function getTruckAccessList(data) {
  const url = global.requestUrl + '/truckAccess/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取过磅列表
export function getWeighBridgeList(data) {
  const url = global.requestUrl + '/weighbridge/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取灌料列表
export function getMaterialCheckList(data) {
  const url = global.requestUrl + '/dualCheck/history?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 获取消息推送列表
export function getProjectConfigList(data) {
  const url = global.requestUrl + '/projectConfig/list'
  return axios.get(url)
}

// 获取货车道闸列表
export function getAggregateTruckStay(data) {
  const url = global.requestUrl + '/truckAccess/exitCar'
  return axios.get(url)
}

